import React, { useEffect, useState } from 'react';
import VipCard from './VipCard';
import { getVipTypeList } from '../../restful/vip_api'
import VipCircleUn from '@/assets/images/vip/vip_circle_un.png';
import VipCircleSe from '@/assets/images/vip/vip_circle_se.png';
import { JsBridge } from "../../utils/JsBridge"; // 从 index.tsx 导入 tokenPromise
interface MembershipType {
  id: number;
  name: string;
  money: number;
  vipDay: number;
}

const VipPanel = (props: {
  isNeedUpdate: boolean;
}) => {
  const { isNeedUpdate } = props;
  const [membershipTypes, setMembershipTypes] = useState<MembershipType[]>([]);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [agreePrivacy, setAgreePrivacy] = useState<boolean>(false);
  const [swipeAnimation, setSwipeAnimation] = useState<boolean>(false);

  useEffect(() => {
    // 模拟从接口获取会员卡数据
    const fetchVipTypes = async () => {
      const response = await getVipTypeList(); // 你的接口地址
      if (response?.data?.data) {
        const list = response.data.data;
        console.log('vip-list', list);
        setMembershipTypes(list);
        if (list.length > 0) {
          setSelectedId(list[0]?.id)
        }
      }
    };
    fetchVipTypes();
  }, []);

  const handleCardClick = (id: number) => {
    setSelectedId(id);
  };

  const handlePrivacyClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    const data = JSON.stringify({ url: "https://deerbook.cn/single-h5/vip_privacy_policy.html", title: "用户协议" });
    JsBridge.openWebPage(data);
  };

  const buyVipClick = () => {
    if (isNeedUpdate) {
      console.log("更新vip");
      JsBridge.updateAppVersion({ sourceFrom: 'H5' });
    } else if (agreePrivacy && selectedId) {
      const data = JSON.stringify({ goodsId: selectedId });
      JsBridge.buyVip(data);
    } else {
      // Trigger the swipe animation and show alert
      setSwipeAnimation(true);
      setTimeout(() => setSwipeAnimation(false), 1000); // Stop the swipe after 1 second
    }
  };
  // 然后在你的全局样式或 TSX 文件中添加以下样式：
  const customStyles = `
.scrollbar-hidden::-webkit-scrollbar {
  display: none;
}

.scrollbar-hidden {
  -ms-overflow-style: none;  /* IE 和 Edge */
  scrollbar-width: none;     /* Firefox */
}
.swipe-animation {
  animation: swipe 0.3s ease-in-out;
}

  @keyframes swipe {
    0% {
        transform: translateX(0);
    }
    50% {
        transform: translateX(10px);
    }
    100% {
        transform: translateX(0);
    }
  }
`;

  // 在组件中应用样式
  useEffect(() => {
    const style = document.createElement('style');
    style.appendChild(document.createTextNode(customStyles));
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, [customStyles]);

  //只有当 membershipTypes 有值时才渲染 VipPanel
  if (membershipTypes.length === 0) {
    return null; // 或者返回一个加载中的状态，比如 <div>加载中...</div>
  }
  return (
    <div className="fixed bottom-0 left-0 w-full flex flex-col justify-between bg-[#FFEFD5] shadow-lg h-[210px] p-[20px]">
      
      <div className="flex flex-row justify-between flex-nowrap overflow-x-auto scrollbar-hidden">
          {membershipTypes.map((item, index) => (
            <VipCard
              key={item.id}
              name={item.name}
              money={item.money}
              corner={"特惠"}
              isSelected={item.id === selectedId}
              onClick={() => handleCardClick(item.id)}
              className={`flex-shrink-0 mr-[12px]`} // 直接在 VipCard 上设置样式
            />
          ))}
        </div>
      <div className='flex flex-row items-center justify-between'>
        
        <div className={`flex flex-row  flex-shrink-0 items-center ${swipeAnimation ? 'swipe-animation' : ''}`} onClick={() => {
            setAgreePrivacy(!agreePrivacy);
          }} >
            <img alt='' src={agreePrivacy ? VipCircleSe : VipCircleUn} className='w-[12px] h-[12px] mr-[6px]' />
            <div className="text-[#A19358] text-[12px] font-normal">开通前请阅读</div>
            <div
              className="text-[#333] text-[12px] font-normal"
              onClick={handlePrivacyClick}
            >
              《会员协议》
            </div>
          </div>

        <div style={{
          background: 'linear-gradient(90deg, #FF7DB4 0%, #FF6E30 100%)',
          boxShadow: '0px 4px 4px 0px rgba(220, 120, 120, 0.25)'
        }} className="text-[#fff] text-[18px] font-semibold text-center w-[140px] h-[50px] leading-[50px] rounded-[25px]" onClick={buyVipClick}>
          微信支付
        </div>
      </div>
    </div>
  );
};

export default VipPanel;